export default __webpack_public_path__ + "static/media/milestone 4800.7969e3fa.svg";